import React, { useState } from 'react';
import Select from 'react-select';

const SurveyTypeData = [
    { value: 1, label: 'PB Residence Field Verification' },
    { value: 2, label: 'CB Residence Field Verification' },
    { value: 3, label: 'PB Employment Field Verification' },
    { value: 4, label: 'CB Employment Field Verification' },
    { value: 5, label: 'PB Business Field Verification' },
    { value: 6, label: 'CB Business Field Verification' },
    { value: 7, label: 'PB Trade Field Verification' },
    { value: 8, label: 'CB Trade Field Verification' },
    { value: 9, label: 'Motor Vehicle Inspection' },
  ];
  
const LeadListFilter = (props) => {
  let userList = props.userList;

  const [filterDataCopy, setfilterDataCopy] = useState({...props.filterData});

  const handleSurveyType = (e) => {
    setfilterDataCopy(prev=> ({
        ...prev,
        survey_type_id: e.value,
    }))
  };

  const handleUserList = (e) => {
    setfilterDataCopy(prev=> ({
        ...prev,
        assigned_to: +e.value,
    }))
  };

  const callFilterReset = (e) => {
    delete filterDataCopy.search_text;
    delete filterDataCopy.survey_type_id;
    delete filterDataCopy.assigned_to;

    setfilterDataCopy({...filterDataCopy});
    props.setFilterData({...filterDataCopy})
    e.preventDefault();
    props.setOffset(0);
    props.setActiveTab("first");
  }

  const submitFilter = (e) => {
    props.setFilterData({...filterDataCopy});
    props.setActiveTab("first");
  }

  console.log("*************",props.filterData)

  return (
    <>
      <div className="lead-list-filter">
        <div className="filter-filed-form">
          <fieldset className="search-bx">
            <div className="material">
              <input
                id='search_text'
                title='Search By Task ID, Customer Name, Mob No.'
                type="text"
                placeholder="Search By Task ID, Customer Name, Mob No."
                name="search_text"
                className="form-input"
                value={filterDataCopy.search_text || ""}
                onChange={(e)=> setfilterDataCopy(prev=> ({
                    ...prev,
                    search_text: e.target.value,
                }))}
              />
              <i className="ic-search"></i>
            </div>
          </fieldset>

          <fieldset className="single-select">
            <div className="material">
              <Select
                value={SurveyTypeData.filter(v=> v.value === filterDataCopy.survey_type_id)}
                onChange={handleSurveyType}
                options={SurveyTypeData}
                placeholder="Survey Type"
                className="react-select"
                classNamePrefix="react-select"
              />
            </div>
          </fieldset>

          <fieldset className="single-select">
            <div className="material">
              <Select
                value={userList.filter(v=> +v.value === filterDataCopy.assigned_to)}
                onChange={handleUserList}
                options={userList}
                placeholder="Assign to"
                className="react-select"
                classNamePrefix="react-select"
              />
            </div>
          </fieldset>
        </div>

        <div className="more-filter">
          <div className="filter-option">
            <div className="dropdown">
              <div className="text-btn d-flex">
                <div className="btn-submit-reset top-btn-none">
                  <button type="submit" className="btn-primary" onClick={submitFilter}>
                    Search
                  </button>
                  <button className="btn-reset" onClick={callFilterReset}>Reset</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadListFilter;
